import React from 'react'
import IMG from './next.png'

function Next() {
  return (<img src={IMG} style={{width:"200px",height:"150px"}} alt='nextjs'/>
  )
}

export default Next